









































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Acl, AclUserGroup, EffectivePermissionAcl, ResourceAccess, ResourceClaim, ResourceType } from "@/services/security/types";
import { userResourceAclFields } from "@/components/users/fields/userResourceAclFields";
import AddResourceMenu from "@/components/users/AddResourceMenu.vue";
import SelectChannelModal from "@/components/channels/modals/SelectChannelModal.vue";
import SelectSolutionModal from "@/components/solutions/modals/SelectSolutioModal.vue";
import SelectContentTemplateModal from "@/components/contentTemplates/modals/SelectContentTemplateModal.vue";
import { Channel } from "@/services/channels/types";
import { Solution } from "@/services/solutions/types";
import { ContentTemplate } from "@/services/contentTemplates/types";
import ResourceAclDeleteModal from "@/components/users/modals/ResourceAclDeleteModal.vue";
import vSelect from "vue-select";
import { forEach } from "lodash";
import { getUserInheritedAcl } from "@/services/security/accessControlService";
import i18n from "@/i18n";
@Component({
    components: {
        ResourceAclDeleteModal,
        SelectContentTemplateModal,
        AddResourceMenu,
        SelectChannelModal,
        SelectSolutionModal,
        vSelect
    }
})
export default class UserResourcesACL extends Vue {
        @Prop() acl!: Acl[];
        @Prop() inheritedAcls!: EffectivePermissionAcl[];
        @Prop() collapseState!: boolean;
        // local state
        localCollapseState = true;
        localAcl = [] as Acl[];
        searchQuery = "";
        fields = userResourceAclFields;
        resourceClaim = ResourceClaim;
        resourceType = ResourceType;
        resourceAccess = ResourceAccess;
        filterResourceType = null;
        filterResourceAccess = null;
        // lifecycle hooks
        mounted() {
            this.localCollapseState = this.collapseState;
        }

        @Watch("acl")
        onAclChanged(value: boolean, oldValue: any) {
            this.localAcl = this.acl.filter(acl => acl.type !== "Folder");
        }

        // computed
        // Get effective permission acls
        get effectivePermissionAcls(): EffectivePermissionAcl[] {
            var effectiveAcls = [] as EffectivePermissionAcl[];
            effectiveAcls = JSON.parse(JSON.stringify(this.inheritedResourceAcls)); // Make a copy of inheritedAcls
            // merge direct and inherited acls.
            this.localAcl.forEach((acl:Acl) => {
                const effectivePermissionAcl: EffectivePermissionAcl = {
                    resourceId: acl.resourceId,
                    type: acl.type,
                    name: acl.name,
                    claim: acl.claim,
                    templateType: acl.templateType,
                    resourceAccesses: [ResourceAccess.Direct],
                    userGroups: []
                };
                // Add Direct Resource Access on Acl if the acl is inherited and directly added.
                const existingAclIndex = effectiveAcls.findIndex(existingAcl => existingAcl.resourceId === acl.resourceId);
                if (existingAclIndex !== -1) {
                    var existedAcl = effectiveAcls[existingAclIndex];
                    if (existedAcl.resourceAccesses.some(acl => acl === ResourceAccess.UserGroup)) {
                        existedAcl.resourceAccesses = [ResourceAccess.Direct, ResourceAccess.UserGroup];
                    }
                } else {
                    effectiveAcls.push(effectivePermissionAcl);
                }
            });
            return effectiveAcls;
        }

        get inheritedResourceAcls(): EffectivePermissionAcl[] {
            return this.inheritedAcls.filter(x => x.type !== "Folder");
        }

        get filteredData() {
            return this.effectivePermissionAcls && this.effectivePermissionAcls
                .filter(x => (this.searchQuery === "" ||
                    (x.name.toLowerCase().includes(this.searchQuery.toLowerCase()))) &&
                    (this.filterResourceType === null || x.type === this.filterResourceType) &&
                    (this.filterResourceAccess === null || (x.resourceAccesses && x.resourceAccesses.some(access => access === this.filterResourceAccess))));
        }

        get getResourceAccess() {
            return Object.keys(this.resourceAccess).map(key => ({ text: i18n.t("acl." + key), value: key }));
        }

        get getResourceType() {
            return Object.keys(this.resourceType).map(key => ({ text: i18n.t("common." + this.pascalCaseToCamelCase(key)), value: key }));
        }

        // methods
        pascalCaseToCamelCase(value: string) {
            return value.length > 5 ? value.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
                return index === 0 ? word.toLowerCase() : word.toUpperCase();
            }).replace(/\s+/g, "") : value.toLowerCase();
        }

        aclTitle(type: string) {
            const t = type.toLowerCase();
            if (t === "channel") return this.$t("channels.editTitle");
            if (t === "solution") return this.$t("solution.editTitle");
            if (t === "template" || t === "contenttemplate") return this.$t("contentTemplates.edit");
            return "";
        }

        onChannelSelected(channels: Channel[]) {
            channels.forEach(channel => {
                const acl = {
                    resourceId: channel.id,
                    name: channel.name,
                    claim: this.resourceClaim.Access,
                    type: this.resourceType.Channel
                } as Acl;

                this.addAcl(acl);
            });
        }

        onSolutionSelected(solutions: Solution[]) {
            solutions.forEach(solution => {
                const acl = {
                    resourceId: solution.id,
                    name: solution.name,
                    claim: this.resourceClaim.Access,
                    type: this.resourceType.Solution
                } as Acl;

                this.addAcl(acl);
            });
        }

        onContentTemplateSelected(cts: ContentTemplate[]) {
            cts.forEach(ct => {
                const acl = {
                    resourceId: ct.id,
                    name: ct.name,
                    claim: this.resourceClaim.Access,
                    type: this.resourceType.ContentTemplate,
                    templateType: ct.type
                } as Acl;

                this.addAcl(acl);
            });
        }

        addAcl(acl: Acl) {
            if (this.localAcl.some(x => x.resourceId === acl.resourceId)) {
                return;
            };
            this.localAcl.unshift(acl);
        }

        onOpenResourcePrompt(resource: string) {
            switch (resource) {
            case "channel":
                (this.$refs.selectChannelModal as any).open(true);
                return;
            case "solution":
                (this.$refs.selectSolutionModal as any).open(null, false, true);
                return;
            case "contentTemplate":
                (this.$refs.selectContentTemplateModal as any).open(true);
            }
        }

        getResourceDetailsUrl(acl: Acl) {
            switch (acl.type) {
            case "Channel":
                return `/channel/${acl.resourceId}/update`;
            case "Solution":
                return `/solutions/${acl.resourceId}/update`;
            case "ContentTemplate":
                if (acl.templateType === "fixedhtml") {
                    return `/templates/${acl.resourceId}/update/fixedhtml`;
                } else if (acl.templateType === "html") {
                    return `/templates/${acl.resourceId}/update/html`;
                }
                break;
            default:
                return "/";
            }
        }

        getResourceUserGroupsUrl(aclUserGroup: AclUserGroup) {
            return `/UserGroups/${aclUserGroup.groupId}/update`;
        }

        getResourceUserGroupsName(aclUserGroup: AclUserGroup) {
            return aclUserGroup.groupName;
        }

        removeResource(acl: Acl) {
            (this.$refs.deleteAclModal as any).open(acl.resourceId, acl.name);
        }

        onDeleted(id: string) {
            const item = this.localAcl.find(x => x.resourceId === id);
            if (!item) {
                return;
            }
            this.localAcl = this.localAcl.filter(x => x.resourceId !== id);
        }

        clearFilter() {
            this.filterResourceType = null;
            this.filterResourceAccess = null;
        }

        isInheritedResource(acl: EffectivePermissionAcl): boolean {
            const hasDirectAccess = acl.resourceAccesses.includes(ResourceAccess.Direct);
            return !hasDirectAccess; // used to disable delete button if resource is inherited from user group.
        }

        formatAccess(access: Array<ResourceAccess>) {
            var formattedAccess = access.map(access => i18n.t(`acl.${ResourceAccess[access]}`));
            return formattedAccess.join(", ");
        }

        // events
        emitData() {
            this.$emit("aclUpdated", this.localAcl);
        }

        setState(state:boolean) {
            if (this.localCollapseState === state) return;

            this.localCollapseState = state;
            this.$emit("componentStateChanged", { name: "UserResourcesACL", state: state });
        }
}
